import React from 'react';
import PropTypes from 'prop-types';

function L2Button({ activeColor, color, value }) {
  return (
    <>
      <path
        d="M157.406 97.3703C157.406 97.3703 184.074 94.8697 198.672 94.8697C213.27 94.8697 238.062 96.7452 238.062 96.7452C238.062 96.7452 235.534 61.8135 234.148 56.1087C232.761 50.4041 227.868 39.4635 220.365 34.3058C212.862 29.1481 210.66 26.413 201.852 26.413C193.045 26.413 181.138 31.4143 173.635 43.1364C166.132 54.8584 157.406 97.3703 157.406 97.3703Z"
        fill={color}
      />
      <path
        d="M157.406 97.3703C157.406 97.3703 184.074 94.8697 198.672 94.8697C213.27 94.8697 238.062 96.7452 238.062 96.7452C238.062 96.7452 235.534 61.8135 234.148 56.1087C232.761 50.4041 227.868 39.4635 220.365 34.3058C212.862 29.1481 210.66 26.413 201.852 26.413C193.045 26.413 181.138 31.4143 173.635 43.1364C166.132 54.8584 157.406 97.3703 157.406 97.3703Z"
        fill={activeColor}
        stroke={activeColor}
        strokeWidth="3px"
        style={{ opacity: value }}
      />
    </>
  );
}

L2Button.propTypes = {
  activeColor: PropTypes.string,
  color: PropTypes.string,
  value: PropTypes.number,
};

L2Button.defaultProps = {
  activeColor: '#FFFFFF',
  color: '#000201',
  value: 0,
};

export default L2Button;
